module.exports = __webpack_public_path__ + "img/ips.0bf490ed.png";